<template>
  <div class='personal'>
    <div class='left-info'>
      <div class='top-avatar'>
        <p class="avatar-wrap"><img class='avatar' :src='userinfo.userIcon'/></p>
        <p class='username'>{{userinfo.userNick}}</p>
      </div>
      <div class='bottom-links'>
        <router-link to='/navigator/personal/info'>个人中心</router-link>
        <router-link to='/navigator/personal/info/orders'>订单管理</router-link>
        <router-link to='/navigator/personal/info/property'>物业查询</router-link>
        <router-link to='/navigator/personal/info/account'>账户管理</router-link>
        <router-link to='/navigator/personal/info/invoice'>发票管理</router-link>
        <router-link to='/navigator/personal/info/noticeHistory'>历史消息</router-link>
      </div>
    </div>
    <div class='right-view'>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      userinfo: {
        userIcon: '',
        userNick: '',
      },
    };
  },
  methods: {
    ...mapMutations(['change_user']),
  },
  computed: {
    ...mapGetters(['token', 'user']),
  },
  created() {
    this.userinfo.userIcon = this.user.userIcon;
    this.userinfo.userNick = this.user.userNick;
    this.$root.eventHub.$on('updateIcon', (avatar, nick) => {
      this.userinfo.userIcon = avatar;
      this.userinfo.userNick = nick;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.personal{
  @include clear-float;
  padding: 50px 0;
  .left-info{
    padding: 20px;
    float: left;
    width: 240px;
    box-sizing: border-box;
    background: #FFF;
    .top-avatar{
      box-sizing: border-box;
      border-bottom: 1px solid #e4e4e4;
      .avatar-wrap{
        text-align: center;
        .avatar{
          margin: 0 auto;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          border: none;
          vertical-align: top;
        }
      }
      .username{
        margin: 20px 0;
        font-size: 16px;
        color: #333333;
        font-weight: 600;
        text-align: center;
      }
    }
    .bottom-links{
      padding: 20px 0;
      a{
        display: block;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        line-height: 48px;
        &.router-link-exact-active{
          background: #f4f4f4;
          color: #d9262c;
        }
      }
    }
  }
  .right-view{
    position: relative;
    float: right;
    width: 940px;
    // height: 600px;
    .prompt-pane{
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/navigator/personal/components/PersonalIndex.vue